// Set up HashMap for Maintenance Schedule

import { I18n } from 'react-redux-i18n';

function getNthDayInMonth(month: number) {
    const date = new Date();
    const year = date.getFullYear();

    const nth = 3; // every month 3rd week
    const day = 6; // Saturday

    // Create new date for 1st day of month
    const d = new Date(year, month);
    d.setDate(1 + ((7 - d.getDay() + day) % 7) + ((nth - 1) * 7));
    return `${(`0${d.getMonth() + 1}`).slice(-2)}/${d.getDate()}/${d.getFullYear()}`;
}

// Hard-coded in for now, future plans for a servc.
const createMap = (): Map<any, any> => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const maintenanceDates = months.map((month, index) => getNthDayInMonth(index));
    const map = new Map();

    for (let i = 0; i < months.length; i++) map.set(months[i], maintenanceDates[i]);

    return map;
};

// Format date to calculate days diff
const formatDate = (date = new Date()) => {
    const mo = date.getMonth();
    const yr = date.getFullYear();
    const dt = date.getDate();

    return new Date(yr, mo, dt);
};

const getScheduledMaintenanceDates = (languagePreferenceCode: string, dateformat: any) => {
    const a = new Intl.DateTimeFormat(languagePreferenceCode, {
        weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
    });

    return a?.format(dateformat);
};

export const daysUntilScheduledMaintenance = (languagePreferenceCode: string) => {
    // Set up d1 - "now"
    const d1 = formatDate();
    const d1Array = `${d1}`.split(' ');

    // Set up d2
    const d2helper = new Date(createMap().get(d1Array[1]));

    const d2 = formatDate(d2helper);

    // Set up d3
    const d3 = d2helper;
    d3.setDate(d3.getDate() + 1);

    // Diff between days
    const daysLeft = (d2.getTime() - d1.getTime()) / (1000 * 3600 * 24);

    const startTime = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate(), 23, 0, 0);
    const endTime = new Date(d3.getFullYear(), d3.getMonth(), d3.getDate(), 4, 0, 0);

    // Set up Service Start/End Dates For Message
    const servicesDownStartDate = getScheduledMaintenanceDates(languagePreferenceCode, startTime);
    const servicesDownEndDate = getScheduledMaintenanceDates(languagePreferenceCode, endTime);
    const timezoneCode = startTime.toLocaleDateString(languagePreferenceCode, { timeZoneName: 'short' })?.split(/\s+(?=[A-Z]{3})/)[1];
    // eslint-disable-next-line max-len
    const message = `${I18n.t('scheduled-maintenance')} ${servicesDownStartDate} ${timezoneCode} ${I18n.t('to')} ${servicesDownEndDate} ${timezoneCode} ${I18n.t('end-sentence') ? I18n.t('end-sentence') : ''}`;
    return { daysLeft, message };
};
